__turbopack_context__.v({
  "resultList": "ResultList-module__7uG_oW__resultList",
  "resultListItem": "ResultList-module__7uG_oW__resultListItem",
  "resultListItemCategory": "ResultList-module__7uG_oW__resultListItemCategory",
  "resultListItemIsActive": "ResultList-module__7uG_oW__resultListItemIsActive",
  "resultListItemIsDisabled": "ResultList-module__7uG_oW__resultListItemIsDisabled",
  "resultListItemSeparator": "ResultList-module__7uG_oW__resultListItemSeparator",
});
